/**
 * @generated SignedSource<<6bcd2eee99e2a5564f6867b2e16a82ef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "HIERARCHY_ASC" | "HIERARCHY_DESC" | "HIERARCHY_LEVEL_ASC" | "HIERARCHY_LEVEL_DESC" | "ID_ASC" | "ID_DESC" | "LATEST_UPDATE_DATE_ASC" | "LATEST_UPDATE_DATE_DESC" | "NAME_ASC" | "NAME_DESC" | "PHASE_ID_ASC" | "PHASE_ID_DESC" | "PROJECT_COUNT_ASC" | "PROJECT_COUNT_DESC" | "SCORE_ASC" | "SCORE_DESC" | "START_DATE_ASC" | "START_DATE_DESC" | "TARGET_DATE_ASC" | "TARGET_DATE_DESC" | "WATCHER_COUNT_ASC" | "WATCHER_COUNT_DESC" | "WATCHING_ASC" | "WATCHING_DESC";
export type DirectoryViewGoalQuery$variables = {
  after?: string | null;
  containerId?: string | null;
  directoryViewUuid?: string | null;
  first?: number | null;
  includeFollowerCount: boolean;
  includeFollowing: boolean;
  includeLastUpdated: boolean;
  includeOwner: boolean;
  includeRelatedProjects: boolean;
  includeStatus: boolean;
  includeTags: boolean;
  includeTargetDate: boolean;
  includeTeam: boolean;
  includedCustomFieldUuids?: ReadonlyArray<string> | null;
  skipTableTql: boolean;
  sorts?: ReadonlyArray<GoalSortEnum | null> | null;
  tql?: string | null;
  workspaceUuid?: string | null;
};
export type DirectoryViewGoalQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryTableViewGoal" | "GoalTimeline">;
};
export type DirectoryViewGoalQuery = {
  response: DirectoryViewGoalQuery$data;
  variables: DirectoryViewGoalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "directoryViewUuid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFollowerCount"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeFollowing"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeLastUpdated"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOwner"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeRelatedProjects"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeStatus"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTags"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTargetDate"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTeam"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includedCustomFieldUuids"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipTableTql"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sorts"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tql"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v18 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v19 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v20 = {
  "kind": "Variable",
  "name": "directoryViewUuid",
  "variableName": "directoryViewUuid"
},
v21 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v22 = {
  "kind": "Variable",
  "name": "includedCustomFieldUuids",
  "variableName": "includedCustomFieldUuids"
},
v23 = {
  "kind": "Variable",
  "name": "sorts",
  "variableName": "sorts"
},
v24 = {
  "kind": "Variable",
  "name": "workspaceUuid",
  "variableName": "workspaceUuid"
},
v25 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "tql"
},
v26 = {
  "kind": "ScalarField",
  "name": "id"
},
v27 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v25/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/)
],
v28 = {
  "kind": "ScalarField",
  "name": "count"
},
v29 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v30 = {
  "kind": "ScalarField",
  "name": "value"
},
v31 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v32 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v33 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "ScalarField",
  "name": "score"
},
v35 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v33/*: any*/),
    (v30/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "key"
},
v37 = {
  "concreteType": "GoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v38 = {
  "kind": "ScalarField",
  "name": "name"
},
v39 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v40 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v41 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "archived"
},
v43 = [
  (v26/*: any*/)
],
v44 = {
  "kind": "InlineFragment",
  "selections": (v43/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v45 = [
  {
    "kind": "ScalarField",
    "name": "canSetMultipleValues"
  }
],
v46 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v47 = {
  "kind": "ScalarField",
  "name": "picture"
},
v48 = {
  "kind": "ScalarField",
  "name": "type"
},
v49 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewGoalQuery",
    "selections": [
      {
        "args": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          {
            "kind": "Variable",
            "name": "includeFollowerCount",
            "variableName": "includeFollowerCount"
          },
          {
            "kind": "Variable",
            "name": "includeFollowing",
            "variableName": "includeFollowing"
          },
          {
            "kind": "Variable",
            "name": "includeLastUpdated",
            "variableName": "includeLastUpdated"
          },
          {
            "kind": "Variable",
            "name": "includeOwner",
            "variableName": "includeOwner"
          },
          {
            "kind": "Variable",
            "name": "includeRelatedProjects",
            "variableName": "includeRelatedProjects"
          },
          {
            "kind": "Variable",
            "name": "includeStatus",
            "variableName": "includeStatus"
          },
          {
            "kind": "Variable",
            "name": "includeTags",
            "variableName": "includeTags"
          },
          {
            "kind": "Variable",
            "name": "includeTargetDate",
            "variableName": "includeTargetDate"
          },
          {
            "kind": "Variable",
            "name": "includeTeam",
            "variableName": "includeTeam"
          },
          (v22/*: any*/),
          {
            "kind": "Variable",
            "name": "skipTableTql",
            "variableName": "skipTableTql"
          },
          (v23/*: any*/),
          {
            "kind": "Variable",
            "name": "tql",
            "variableName": "tql"
          },
          (v24/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "DirectoryTableViewGoal"
      },
      {
        "args": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v25/*: any*/),
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sorts"
          },
          (v24/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalTimeline"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v16/*: any*/),
      (v17/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v15/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewGoalQuery",
    "selections": [
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "wrapTextEnabled"
              },
              (v26/*: any*/)
            ]
          },
          (v26/*: any*/)
        ]
      },
      {
        "alias": "goalTimeline",
        "args": (v27/*: any*/),
        "concreteType": "GoalConnection",
        "kind": "LinkedField",
        "name": "goalTql",
        "plural": false,
        "selections": [
          (v28/*: any*/),
          {
            "concreteType": "GoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Goal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creationDate"
                  },
                  {
                    "concreteType": "GoalState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      (v31/*: any*/),
                      (v33/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetDateConfidence"
                  },
                  (v26/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/)
                ]
              },
              (v40/*: any*/)
            ]
          },
          (v41/*: any*/)
        ]
      },
      {
        "alias": "goalTimeline",
        "args": (v27/*: any*/),
        "filters": [
          "workspaceUuid",
          "containerId",
          "q",
          "directoryViewUuid",
          "sorts"
        ],
        "handle": "connection",
        "key": "GoalTimeline__goalTimeline",
        "kind": "LinkedHandle",
        "name": "goalTql"
      },
      {
        "condition": "skipTableTql",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v27/*: any*/),
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalTqlFullHierarchy",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v36/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "hasSubgoalMatches"
                      },
                      {
                        "concreteType": "ManagerDataResponse",
                        "kind": "LinkedField",
                        "name": "managerData",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ManagerData",
                            "kind": "LinkedField",
                            "name": "managers",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "managerProfile",
                                "plural": false,
                                "selections": [
                                  (v38/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "directReports"
                              }
                            ]
                          }
                        ]
                      },
                      (v29/*: any*/),
                      (v37/*: any*/),
                      (v38/*: any*/),
                      (v42/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "parentGoal",
                        "plural": false,
                        "selections": (v43/*: any*/)
                      },
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Goal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  (v26/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v28/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          (v22/*: any*/)
                        ],
                        "concreteType": "CustomFieldConnection",
                        "kind": "LinkedField",
                        "name": "customFields",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomFieldEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v39/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "definition",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v29/*: any*/)
                                            ],
                                            "type": "CustomFieldDefinitionNode",
                                            "abstractKey": "__isCustomFieldDefinitionNode"
                                          },
                                          (v44/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "CustomFieldNode",
                                    "abstractKey": "__isCustomFieldNode"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldNumberSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "numberValue",
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          (v26/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "NumberCustomField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "definition",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v45/*: any*/),
                                            "type": "TextSelectCustomFieldDefinition"
                                          },
                                          (v44/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "CustomFieldTextSavedValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          (v28/*: any*/),
                                          {
                                            "concreteType": "CustomFieldTextSavedValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "CustomFieldTextSavedValueNode",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v26/*: any*/),
                                                  (v30/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "TextSelectCustomField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "definition",
                                        "plural": false,
                                        "selections": [
                                          (v39/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": (v45/*: any*/),
                                            "type": "UserCustomFieldDefinition"
                                          },
                                          (v44/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "UserConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          (v28/*: any*/),
                                          {
                                            "concreteType": "UserEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "UserPII",
                                                    "kind": "LinkedField",
                                                    "name": "pii",
                                                    "plural": false,
                                                    "selections": [
                                                      (v46/*: any*/),
                                                      (v38/*: any*/),
                                                      (v47/*: any*/)
                                                    ]
                                                  },
                                                  (v26/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "UserCustomField"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextSavedValueNode",
                                        "kind": "LinkedField",
                                        "name": "value",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": "textValue",
                                            "kind": "ScalarField",
                                            "name": "value"
                                          },
                                          (v26/*: any*/)
                                        ]
                                      }
                                    ],
                                    "type": "TextCustomField"
                                  },
                                  (v44/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "percentage"
                          }
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "snapshotValue",
                                    "plural": false,
                                    "selections": [
                                      (v30/*: any*/),
                                      (v26/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "startValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetValue"
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v48/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "subType"
                                      },
                                      (v26/*: any*/),
                                      (v42/*: any*/),
                                      (v38/*: any*/)
                                    ]
                                  },
                                  (v26/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v39/*: any*/),
                      {
                        "condition": "includeLastUpdated",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                          }
                        ]
                      },
                      {
                        "condition": "includeFollowing",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "watching"
                          }
                        ]
                      },
                      {
                        "condition": "includeTargetDate",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "confidence"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "label"
                              },
                              (v33/*: any*/),
                              {
                                "alias": "tooltip",
                                "args": (v49/*: any*/),
                                "kind": "ScalarField",
                                "name": "label",
                                "storageKey": "label(longFormat:true)"
                              },
                              {
                                "alias": "localizedTooltip",
                                "args": (v49/*: any*/),
                                "concreteType": "LocalizationField",
                                "kind": "LinkedField",
                                "name": "localizedLabel",
                                "plural": false,
                                "selections": (v32/*: any*/),
                                "storageKey": "localizedLabel(longFormat:true)"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "overdue"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeStatus",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "GoalState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              {
                                "alias": "goalStateValue",
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              (v35/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeOwner",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "aaid"
                              },
                              {
                                "concreteType": "UserPII",
                                "kind": "LinkedField",
                                "name": "pii",
                                "plural": false,
                                "selections": [
                                  (v47/*: any*/),
                                  (v46/*: any*/)
                                ]
                              },
                              (v26/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeRelatedProjects",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "ProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              {
                                "concreteType": "ProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Project",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v36/*: any*/),
                                      (v38/*: any*/),
                                      (v29/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "private"
                                      },
                                      {
                                        "concreteType": "IconURIs",
                                        "kind": "LinkedField",
                                        "name": "iconUrl",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "ThemeURIs",
                                            "kind": "LinkedField",
                                            "name": "square",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "light"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "dark"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "transparent"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeTeam",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "GoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teamsV2",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GoalTeamEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "avatarUrl"
                                      },
                                      (v38/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "teamId"
                                      },
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v28/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeTags",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "TagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v38/*: any*/),
                                      (v29/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "description"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "projectUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "goalUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "helpPointerUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "watcherCount"
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v28/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "includeFollowerCount",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v40/*: any*/)
                ]
              },
              (v41/*: any*/),
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "args": (v27/*: any*/),
            "filters": [
              "q",
              "workspaceUuid",
              "containerId",
              "sorts",
              "directoryViewUuid"
            ],
            "handle": "connection",
            "key": "DirectoryTable__goalTqlFullHierarchy",
            "kind": "LinkedHandle",
            "name": "goalTqlFullHierarchy"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4a8eb7c84c3abf783a1f10b2cd92e3b1",
    "id": null,
    "metadata": {},
    "name": "DirectoryViewGoalQuery",
    "operationKind": "query",
    "text": "query DirectoryViewGoalQuery(\n  $tql: String\n  $workspaceUuid: UUID\n  $containerId: String\n  $after: String\n  $first: Int\n  $sorts: [GoalSortEnum]\n  $directoryViewUuid: UUID\n  $includeFollowerCount: Boolean!\n  $includeFollowing: Boolean!\n  $includeLastUpdated: Boolean!\n  $includeOwner: Boolean!\n  $includeRelatedProjects: Boolean!\n  $includeStatus: Boolean!\n  $includeTargetDate: Boolean!\n  $includeTeam: Boolean!\n  $includeTags: Boolean!\n  $includedCustomFieldUuids: [UUID!]\n  $skipTableTql: Boolean!\n) {\n  ...DirectoryTableViewGoal_3JCCLt\n  ...GoalTimeline_16XmRm\n}\n\nfragment CustomFieldCell on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on CustomFieldNode {\n        __isCustomFieldNode: __typename\n        definition {\n          __typename\n          ... on CustomFieldDefinitionNode {\n            __isCustomFieldDefinitionNode: __typename\n            uuid\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n      ...NumberFieldColumn\n      ...TextSelectFieldColumn\n      ...UserFieldColumn\n      ...TextFieldColumn\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment DirectoryRow_367brx on Goal {\n  id\n  ari\n  key\n  hasSubgoalMatches\n  latestUpdateDate @include(if: $includeLastUpdated)\n  ...GoalNameColumn\n  ...GoalFollowButton @include(if: $includeFollowing)\n  ...GoalActions\n  dueDate @include(if: $includeTargetDate) {\n    ...TargetDate\n  }\n  state @include(if: $includeStatus) {\n    ...GoalState\n  }\n  owner @include(if: $includeOwner) {\n    ...UserAvatar_2aqwkz\n    id\n  }\n  projects @include(if: $includeRelatedProjects) {\n    ...RelatedGoalProjects\n  }\n  teamsV2 @include(if: $includeTeam) {\n    ...TeamOfGoal\n  }\n  tags @include(if: $includeTags) {\n    ...TagColumn\n  }\n  ...FollowerCount_goal @include(if: $includeFollowerCount)\n  customFields(includedCustomFieldUuids: $includedCustomFieldUuids) {\n    ...CustomFieldCell\n  }\n  ...MetricColumn\n}\n\nfragment DirectoryTableViewGoal_3JCCLt on Query {\n  goalTqlFullHierarchy(first: $first, after: $after, q: $tql, workspaceUuid: $workspaceUuid, containerId: $containerId, sorts: $sorts, directoryViewUuid: $directoryViewUuid) @skip(if: $skipTableTql) {\n    count\n    edges {\n      node {\n        id\n        ari\n        ...RootDirectoryRow_367brx\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  currentUser {\n    preferences {\n      wrapTextEnabled\n      id\n    }\n    id\n  }\n}\n\nfragment FollowerCount_goal on Goal {\n  ...GoalFollowersButton\n}\n\nfragment GoalActions on Goal {\n  id\n  name\n  archived\n  parentGoal {\n    id\n  }\n  subGoals {\n    edges {\n      node {\n        archived\n        id\n      }\n    }\n  }\n}\n\nfragment GoalBar on Goal {\n  startDate\n  creationDate\n  state {\n    value\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    score\n    atCompletionState {\n      label(includeScore: false)\n      localizedLabel {\n        messageId\n      }\n      value\n      score\n    }\n  }\n  targetDate\n  targetDateConfidence\n  ...GoalName\n  ...utilsGetGoalTargetEndDate\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n}\n\nfragment GoalFollowersButton on Goal {\n  key\n  watchers {\n    count\n  }\n}\n\nfragment GoalName on Goal {\n  uuid\n  id\n  key\n  ...PlatformGoalIcon\n  name\n}\n\nfragment GoalNameColumn on Goal {\n  id\n  managerData {\n    managers {\n      managerProfile {\n        name\n      }\n      directReports\n    }\n  }\n  ...GoalName\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  goalStateValue: value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalTimeline_16XmRm on Query {\n  goalTimeline: goalTql(first: $first, after: $after, workspaceUuid: $workspaceUuid, containerId: $containerId, q: $tql, directoryViewUuid: $directoryViewUuid, sorts: $sorts) {\n    count\n    edges {\n      node {\n        uuid\n        startDate\n        creationDate\n        ...GoalBar\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        id\n      }\n    }\n  }\n}\n\nfragment MetricColumn on Goal {\n  id\n  uuid\n  ...progressBarMetricTarget\n  ...hasMetric\n  ...MetricChart\n}\n\nfragment NumberFieldColumn on NumberCustomField {\n  value {\n    numberValue: value\n    id\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment RelatedGoalProjects on ProjectConnection {\n  count\n  edges {\n    node {\n      ...ProjectName_data\n      id\n    }\n  }\n}\n\nfragment RootDirectoryRow_367brx on Goal {\n  id\n  ...DirectoryRow_367brx\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment TagColumn on TagConnection {\n  edges {\n    node {\n      ...Tag\n      id\n    }\n  }\n  count\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment TeamOfGoal on GoalTeamConnection {\n  edges {\n    node {\n      avatarUrl\n      name\n      teamId\n      id\n    }\n  }\n  count\n}\n\nfragment TextFieldColumn on TextCustomField {\n  value {\n    textValue: value\n    id\n  }\n}\n\nfragment TextSelectFieldColumn on TextSelectCustomField {\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    count\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserFieldColumn on UserCustomField {\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    count\n    edges {\n      node {\n        pii {\n          accountId\n          name\n          picture\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment hasMetric on Goal {\n  progress {\n    type\n  }\n  metricTargets {\n    edges {\n      node {\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment utilsGetGoalTargetEndDate on Goal {\n  startDate\n  creationDate\n  targetDate\n  targetDateConfidence\n}\n"
  }
};
})();

(node as any).hash = "959ae6e82c77a41e4723f7cba249df15";

export default node;
